/* Layout */
import Layout from '@/views/layout/Layout';
export default [
  {
    path: '/popularscienceManage',
    component: Layout,
    alwaysShow: true,
    meta: {
      title: '自营-科普管理',
      icon: 'component',
    },
    children: [
      {
        path: '/popularscienceManage/popcolumnManage',
        component: () => import('@/myviews/shoppMall/popularscienceManage/popcolumnManage/popcolumnManageList.vue'),
        alwaysShow: false,
        name: 'popcolumnManageList',
        meta: {
          title: '栏目管理',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/popularscienceManage/articleManage',
        component: () => import('@/myviews/shoppMall/popularscienceManage/articleManage/articleManageList.vue'),
        alwaysShow: false,
        name: 'articleManageList',
        meta: {
          title: '文章库管理',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
          keepAlive: true
        }
      },
      {
        path: '/popularscienceManage/videoManage',
        component: () => import('@/myviews/shoppMall/popularscienceManage/videoManage/videoManageList.vue'),
        alwaysShow: false,
        name: 'videoManageList',
        meta: {
          title: '视频库管理',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/popularscienceManage/rdarticleManage',
        component: () => import('@/myviews/shoppMall/popularscienceManage/rdarticleManage/rdarticleManageList.vue'),
        alwaysShow: false,
        name: 'rdarticleManageList',
        meta: {
          title: '推荐文章',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/popularscienceManage/rdvideoManage',
        component: () => import('@/myviews/shoppMall/popularscienceManage/rdvideoManage/rdvideoManageList.vue'),
        alwaysShow: false,
        name: 'rdvideoManageList',
        meta: {
          title: '推荐视频',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/popularscienceManage/recommendManage',
        component: () => import('@/myviews/shoppMall/popularscienceManage/recommendManage/recommendManageList.vue'),
        alwaysShow: false,
        name: 'recommendManageList',
        meta: {
          title: '种草管理',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/popularscienceManage/floorManage',
        component: () => import('@/myviews/shoppMall/popularscienceManage/floorManage/floorManageList.vue'),
        alwaysShow: false,
        name: 'popfloorManage',
        meta: {
          title: '楼层管理',
          icon: 'component',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
    ]
  },
]



// WEBPACK FOOTER //
// ./src/router/shoppMall/popularscienceManage.js